import { PageLayout } from '../layout/PageLayout'
import mapNetherlandsImage from '@app/assets/images/map-netherlands.png'
import crowdBuildingMockupImage from '@app/assets/images/crowdbuilding-mockup.png'
import { Hero } from '@app/components/blocks/hero/Hero'
import { ColumnsSection } from '@app/components/blocks/contentSection/ColumnsSection'
import { OurPartners } from './blocks/OurPartners'
import { Title } from '@app/components/core/typography/Title'
import useMediaQuery from '@app/util/useMediaQuery'
import heroImage from '@app/assets/images/planners-table.jpg'

export const ForExperts = () => {
  const isMobile = useMediaQuery()

  return (
    <PageLayout gap={isMobile ? '2.5rem' : '6.25rem'} marginTop="0">
      <Hero title="Voor experts" backgroundSrc={heroImage} fullWidth />

      <ColumnsSection
        style={{
          alignItems: 'center',
          flexDirection: isMobile ? 'column-reverse' : 'row',
        }}
        columns={[
          {
            imageSrc: crowdBuildingMockupImage,
            imageAlt: 'bedrijfspagina CrowdBuilding',
            imageStyle: {
              marginLeft: 'auto',
            },
          },
          {
            markdown: `## Bedrijfspagina\n
Collectieve bouwprojecten zoals CPO’s en wooncoöperaties zijn de grote belofte voor een eerlijke en duurzame woningmarkt. CrowdBuilding is het platform waar burgers, gemeenten en experts samenwerken om collectieve woningbouw voor iedereen toegankelijk te maken. Dat is een grote uitdaging en daar hebben we alle hulp bij nodig. CrowdBuilding is op zoek naar professionele partners in heel Nederland die onze visie delen en willen meewerken aan dit initiatief.`,
          },
        ]}
      />

      <ColumnsSection
        style={{ alignItems: 'center' }}
        columns={[
          {
            markdown: `## Een landelijk netwerk\n
Bouwgroepen, Wooncoöperaties en zelfbouwers kunnen niet zonder goede professionele ondersteuning. Daarom bouwt CrowdBuilding aan een landelijk netwerk van partijen die kwaliteit, ervaring en betrouwbaarheid kunnen bieden.\n
Met een netwerk van gedreven procesbegeleiders, creatieve architecten, slimme adviseurs en deskundige aannemers kunnen we de wooncrisis in Nederland op een innovatieve en kwalitatieve manier te lijf gaan.`,
          },
          {
            imageSrc: mapNetherlandsImage,
            imageAlt: 'Een landelijk netwerk',
            imageStyle: {
              marginRight: 'auto',
            },
          },
        ]}
      />

      <section>
        <Title.H2
          style={{
            marginBottom: '1.75rem',
            marginTop: 0,
          }}
        >
          Onze partners
        </Title.H2>
        <OurPartners />
      </section>
    </PageLayout>
  )
}
